import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import LiquorIcon from "@mui/icons-material/Liquor";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import SpeedIcon from "@mui/icons-material/Speed";
import StoreIcon from "@mui/icons-material/Store";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import SportsBarIcon from "@mui/icons-material/SportsBar";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import React from "react";
export const APP_LINK = {
  LOGIN: "/",
  REGISTER: "/register",
  FORGOTPASSWORD: "/forgot-password",
  DASHBOARD: "/admin/dashboard",
  ADDPRODUCT: "/admin/sub-brand/add",
  EDITPRODUCT: "/admin/sub-brand/edit/:id",
  VIEWPRODUCT: "/admin/sub-brand/view/:id",
  PRODUCTLIST: "/admin/sub-brands/list",
  PERMISSION: "/admin/permissions",
  ADDWHOLESALER: "/admin/wholesaler/add",
  EDITWHOLESALER: "/admin/wholesaler/edit/:id",
  VIEWWHOLESALER: "/admin/wholesaler/view/:id",
  ONBOARDEDWHOLESALER: "/admin/wholesalers/list",
  ADDBARAGGREGATION: "/admin/bar/add",
  EDITBARAGGREGATION: "/admin/bar/edit/:id",
  VIEWBARAGGREGATION: "/admin/bar/view/:id",
  BARCLUBAGGREGATION: "/admin/bars/list",

  ADDCUSTOMER: "/admin/customer/add",
  EDITCUSTOMER: "/admin/customer/edit/:id",
  VIEWCUSTOMER: "/admin/customer/view/:id",
  CUSTOMERS: "/admin/customers/list",
  CHANGEPASSWORD: "/update/password",
  EDITADMIN: "/admin/profile/edit",
  ADDBRAND: "/admin/brand/add",
  EDITBRAND: "/admin/brand/edit/:id",
  VIEWBRAND: "/admin/brand/view/:id",
  BRANDLIST: "/admin/brands/list",
  ADDTYPEOFALCOHOL: "/admin/typeOfAlcohol/add",
  EDITTYPEOFALCOHOL: "/admin/typeOfAlcohol/edit/:id",
  VIEWTYPEOFALCOHOL: "/admin/typeOfAlcohol/view/:id",
  TYPEOFALCOHOLLIST: "/admin/typesOfAlcohol/list",
  ADMINREPORT: "/admin/salesreport",
  LOGOUT: "/logout",
};
export const items = [
  {
    url: APP_LINK.LOGIN,
  },
  {
    url: APP_LINK.REGISTER,
  },
  {
    url: APP_LINK.FORGOTPASSWORD,
  },
];
const menuItems = [
  {
    key: "dashboard",
    icon: <SpeedIcon />,
    label: "Admin Dashboard",
    url: APP_LINK.DASHBOARD,
  },
  {
    key: "typeOfAlcohol",
    icon: <SportsBarIcon />,
    label: "Alcohol Categories",
    url: APP_LINK.TYPEOFALCOHOLLIST,
  },
  {
    key: "brands",
    icon: <BrandingWatermarkIcon />,
    label: "Brand Management",
    url: APP_LINK.BRANDLIST,
  },
  {
    key: "subBrands",
    icon: <CategoryOutlinedIcon />,
    label: "Sub Brand Management",
    url: APP_LINK.PRODUCTLIST,
  },
  // {
  //   key: "barAggregation",
  //   icon: <CloudSyncOutlinedIcon />,
  //   label: "Bar Aggregation",
  //   submenu: [
  //     { name: "Add New", url: APP_LINK.ADDBARAGGREGATION },
  //     { name: "Bar/Club Sales Report", url: APP_LINK.BARCLUBSALESREPORT },
  //     { name: "BarClubAggregation", url: APP_LINK.BARCLUBAGGREGATION },
  //   ],
  // },
  {
    key: "wholeSalerAggregation",
    icon: <StoreIcon />,
    label: "Wholesaler Management",
    url: APP_LINK.ONBOARDEDWHOLESALER,
  },
  {
    key: "barAggregation",
    icon: <LiquorIcon />,
    label: "Bar & Club Management",
    url: APP_LINK.BARCLUBAGGREGATION,
  },
  {
    key: "customerOrder",
    icon: <PersonIcon />,
    label: "Customer Management",
    url: APP_LINK.CUSTOMERS,
  },
  {
    key: "report",
    icon: <ReceiptLongOutlinedIcon />,
    label: "Business Reports",
    url: APP_LINK.ADMINREPORT,
  },
  {
    key: "permissions",
    icon: <LockOpenIcon />,
    label: "User Permissions",
    url: APP_LINK.PERMISSION,
  },
  {
    key: "profile",
    icon: <AdminPanelSettingsIcon />,
    label: "Edit Profile",
    url: APP_LINK.EDITADMIN,
  },
  {
    key: "changePassword",
    icon: <VpnKeyIcon />,
    label: "Update Password",
    url: APP_LINK.CHANGEPASSWORD,
  },
  {
    key: "logout",
    icon: <LogoutIcon />,
    label: "Sign Out",
    url: APP_LINK.LOGOUT,
  },
];
export default menuItems;
